export default "__VITE_ASSET__CgsrJ8jr__"